import {Icon, IconProps} from '@chakra-ui/react';

export const NoChallengesIcon = (props: IconProps) => (
  <Icon width="200px" height="98px" viewBox="0 0 200 98" fill="none" {...props}>
    <path
      d="M162 0H42C36.4772 0 32 3.13401 32 7V91C32 94.866 36.4772 98 42 98H162C167.523 98 172 94.866 172 91V7C172 3.13401 167.523 0 162 0Z"
      fill="#5AC57D"
      fillOpacity="0.1"
    />
    <g filter="url(#filter0_d_3769_20190)">
      <path
        d="M146 10H11C8.23858 10 6 12.2386 6 15V40C6 42.7614 8.23858 45 11 45H146C148.761 45 151 42.7614 151 40V15C151 12.2386 148.761 10 146 10Z"
        fill="white"
      />
    </g>
    <path
      d="M75 18H49C47.3431 18 46 19.3431 46 21C46 22.6569 47.3431 24 49 24H75C76.6569 24 78 22.6569 78 21C78 19.3431 76.6569 18 75 18Z"
      fill="#5AC57B"
    />
    <path
      d="M93 31H49C47.3431 31 46 32.3431 46 34C46 35.6569 47.3431 37 49 37H93C94.6569 37 96 35.6569 96 34C96 32.3431 94.6569 31 93 31Z"
      fill="#5AC57C"
      fillOpacity="0.3"
    />
    <path
      d="M33 13H14C11.2386 13 9 15.2386 9 18V37C9 39.7614 11.2386 42 14 42H33C35.7614 42 38 39.7614 38 37V18C38 15.2386 35.7614 13 33 13Z"
      fill="black"
    />
    <path
      d="M21.2217 30.78H23.2217L23.2437 30.01C23.2437 28.998 23.8817 28.734 24.7837 28.448C25.6885 28.1906 26.4849 27.6456 27.0525 26.8955C27.6201 26.1453 27.928 25.2307 27.9297 24.29C27.9495 23.7157 27.8499 23.1435 27.6371 22.6096C27.4244 22.0758 27.1031 21.5919 26.6936 21.1886C26.2842 20.7854 25.7954 20.4715 25.2584 20.2669C24.7214 20.0623 24.1477 19.9714 23.5737 20C22.9671 19.9868 22.3642 20.0969 21.8014 20.3237C21.2387 20.5505 20.7279 20.8893 20.3 21.3194C19.8721 21.7495 19.536 22.2621 19.3122 22.8261C19.0883 23.39 18.9813 23.9935 18.9977 24.6H21.0657C21.0579 24.2651 21.1169 23.9321 21.2395 23.6203C21.362 23.3085 21.5455 23.0244 21.7793 22.7845C22.0131 22.5445 22.2924 22.3537 22.6009 22.2231C22.9093 22.0925 23.2408 22.0248 23.5757 22.024C23.8778 22.0065 24.1801 22.0542 24.4621 22.1639C24.7441 22.2737 24.9992 22.4428 25.21 22.6599C25.4208 22.8769 25.5824 23.1368 25.6838 23.4219C25.7852 23.707 25.8241 24.0106 25.7977 24.312C25.7844 24.7999 25.6147 25.2706 25.3137 25.6548C25.0127 26.039 24.5963 26.3164 24.1257 26.446L23.3997 26.734C22.6889 26.9053 22.0684 27.3372 21.6609 27.9443C21.2535 28.5514 21.0889 29.2893 21.1997 30.012L21.2217 30.78ZM22.2117 35.534C22.4076 35.541 22.6028 35.5086 22.7859 35.4388C22.9691 35.369 23.1363 35.2632 23.2778 35.1276C23.4194 34.9921 23.5323 34.8295 23.6099 34.6496C23.6875 34.4696 23.7282 34.276 23.7297 34.08C23.728 33.8842 23.687 33.6908 23.6093 33.5111C23.5316 33.3313 23.4186 33.169 23.2771 33.0337C23.1356 32.8984 22.9685 32.7927 22.7855 32.723C22.6025 32.6534 22.4074 32.6211 22.2117 32.628C22.0161 32.6211 21.821 32.6534 21.638 32.723C21.455 32.7927 21.2878 32.8984 21.1463 33.0337C21.0048 33.169 20.8919 33.3313 20.8142 33.5111C20.7364 33.6908 20.6955 33.8842 20.6937 34.08C20.6952 34.276 20.736 34.4696 20.8136 34.6496C20.8912 34.8295 21.0041 34.9921 21.1456 35.1276C21.2871 35.2632 21.4544 35.369 21.6375 35.4388C21.8206 35.5086 22.0159 35.541 22.2117 35.534Z"
      fill="white"
    />
    <g filter="url(#filter1_d_3769_20190)">
      <path
        d="M54 53H189C190.326 53 191.598 53.5268 192.536 54.4645C193.473 55.4021 194 56.6739 194 58V83C194 84.3261 193.473 85.5979 192.536 86.5355C191.598 87.4732 190.326 88 189 88H54C52.6739 88 51.4021 87.4732 50.4645 86.5355C49.5268 85.5979 49 84.3261 49 83V58C49 56.6739 49.5268 55.4021 50.4645 54.4645C51.4021 53.5268 52.6739 53 54 53V53Z"
        fill="white"
      />
    </g>
    <path
      d="M118 61H92C90.3431 61 89 62.3431 89 64C89 65.6569 90.3431 67 92 67H118C119.657 67 121 65.6569 121 64C121 62.3431 119.657 61 118 61Z"
      fill="#5AC57B"
    />
    <path
      d="M136 74H92C90.3431 74 89 75.3431 89 77C89 78.6569 90.3431 80 92 80H136C137.657 80 139 78.6569 139 77C139 75.3431 137.657 74 136 74Z"
      fill="#5AC57C"
      fillOpacity="0.3"
    />
    <path
      d="M76 56H57C54.2386 56 52 58.2386 52 61V80C52 82.7614 54.2386 85 57 85H76C78.7614 85 81 82.7614 81 80V61C81 58.2386 78.7614 56 76 56Z"
      fill="black"
    />
    <path
      d="M64.2217 73.78H66.2217L66.2437 73.01C66.2437 71.998 66.8817 71.734 67.7837 71.448C68.6885 71.1906 69.4849 70.6456 70.0525 69.8955C70.6201 69.1453 70.928 68.2307 70.9297 67.29C70.9495 66.7157 70.8499 66.1435 70.6371 65.6096C70.4244 65.0758 70.1031 64.5919 69.6936 64.1886C69.2842 63.7854 68.7954 63.4715 68.2584 63.2669C67.7214 63.0623 67.1477 62.9714 66.5737 63C65.9671 62.9868 65.3642 63.0969 64.8014 63.3237C64.2387 63.5505 63.7279 63.8893 63.3 64.3194C62.8721 64.7495 62.536 65.2621 62.3122 65.8261C62.0883 66.39 61.9813 66.9935 61.9977 67.6H64.0657C64.0579 67.2651 64.1169 66.9321 64.2395 66.6203C64.362 66.3085 64.5455 66.0244 64.7793 65.7845C65.0131 65.5445 65.2924 65.3537 65.6009 65.2231C65.9093 65.0925 66.2408 65.0248 66.5757 65.024C66.8778 65.0065 67.1801 65.0542 67.4621 65.1639C67.7441 65.2737 67.9992 65.4428 68.21 65.6599C68.4208 65.8769 68.5824 66.1368 68.6838 66.4219C68.7852 66.707 68.8241 67.0106 68.7977 67.312C68.7844 67.7999 68.6147 68.2706 68.3137 68.6548C68.0127 69.039 67.5963 69.3164 67.1257 69.446L66.3997 69.734C65.6889 69.9053 65.0684 70.3372 64.6609 70.9443C64.2535 71.5514 64.0889 72.2893 64.1997 73.012L64.2217 73.78ZM65.2117 78.534C65.4076 78.541 65.6028 78.5086 65.7859 78.4388C65.9691 78.369 66.1363 78.2632 66.2778 78.1276C66.4194 77.9921 66.5323 77.8295 66.6099 77.6496C66.6875 77.4696 66.7282 77.276 66.7297 77.08C66.728 76.8842 66.687 76.6908 66.6093 76.5111C66.5316 76.3313 66.4186 76.169 66.2771 76.0337C66.1356 75.8984 65.9685 75.7927 65.7855 75.723C65.6025 75.6534 65.4074 75.6211 65.2117 75.628C65.0161 75.6211 64.821 75.6534 64.638 75.723C64.455 75.7927 64.2878 75.8984 64.1463 76.0337C64.0048 76.169 63.8919 76.3313 63.8142 76.5111C63.7364 76.6908 63.6955 76.8842 63.6937 77.08C63.6952 77.276 63.736 77.4696 63.8136 77.6496C63.8912 77.8295 64.0041 77.9921 64.1456 78.1276C64.2871 78.2632 64.4544 78.369 64.6375 78.4388C64.8206 78.5086 65.0159 78.541 65.2117 78.534Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_3769_20190"
        x="0"
        y="7"
        width="157"
        height="47"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3769_20190" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3769_20190" result="shape" />
      </filter>
      <filter
        id="filter1_d_3769_20190"
        x="43"
        y="50"
        width="157"
        height="47"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3769_20190" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3769_20190" result="shape" />
      </filter>
    </defs>
  </Icon>
);
